import React from 'react';

interface MessageParserProps {
  children: React.ReactNode;
  actions: any;
}

const MessageParser: React.FC<MessageParserProps> = ({ children, actions }) => {
  const parse = (message: string) => {
    actions.sendToLLM(message);
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          return React.cloneElement(child, {
            parse,
            actions,
          } as any);
        }
        return child;
      })}
    </div>
  );
};

export default MessageParser;
